import PropTypes from "prop-types";
import "../../theme/Hub.css";

/**
 * Componente de botón tipo "pill"
 *
 * @param {string} label - Texto a mostrar en el botón
 * @param {string} value - Valor asociado al botón
 * @param {boolean} isActive - Indica si el botón está activo
 * @param {function} onClick - Función callback que recibe el value al hacer click
 * @param {string} className - Clases CSS adicionales (opcional)
 * @param {boolean} disabled - Deshabilita el botón (opcional)
 */
export const BtnPill = ({
  label,
  value,
  isActive = false,
  onClick,
  className = "",
  disabled = false,
}) => {
  const handleClick = () => {
    if (!disabled && onClick) {
      onClick(value);
    }
  };

  return (
    <button
      type="button"
      className={`btn-pill ${isActive ? "btn-pill-active" : ""} ${className}`}
      onClick={handleClick}
      disabled={disabled}
      aria-pressed={isActive}
    >
      {label}
    </button>
  );
};

BtnPill.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};
